import React, { useCallback, useEffect, useState } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import prdtl from "../../images/prdtl.jpg";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { getProductById } from "../../../service/Product/ProductService";
import moment from "moment";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import {
  getAllProductDetailslist,
  getInvoiceSupplierList,
  // getSegmentList,
  getUnspcAdd,
  getActiveProduct,
  getFamilyList,
  getClassList,
  getCommodityUnspcList,
  updateBaseQty,
  addUnspscData,
} from "../../../service/Product/ProductService";
import {
  deleteSegment,
  getAddSegment,
  getAddSegmentToAll,
  getSegmentAdd,
  getSegmentList,
  getSegmentUnspcAdd,
  getFamilyUnspcAdd,
  getClassUnspcAdd,
  getSelectedUnspscDetails,
} from "../../../service/Segment/SegmentService";
import { Card, Tooltip, OverlayTrigger, Button } from "react-bootstrap";

import Masonry from "react-masonry-css";
import { searchUnspc } from "../../../service/Segment/SegmentService";
import instance from "../../../WebApi/WebApi";
import SpinnerComponent from "../../components/SpinnerComponent";
import useUnitData from "./UnitData";
import { useTranslation } from "react-i18next";
import { Country } from "country-state-city";
import { Textarea } from "@chakra-ui/react";
import Barcode from "react-barcode";
import debounce from "lodash/debounce";

const Productdetails = () => {
  //Search
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalSearchResult, setTotalSearchResult] = useState(0);
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsEnd, setSearchResultsEnd] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [selectedSearchResult, setSelectedSearchResult] = useState("");

  const { t } = useTranslation();
  //FOR-MASONRY-TRANSFORM
  const breakpointColumnsObj = {
    default: 2,
    1200: 1,
    700: 1,
    500: 1,
  };
  const navigate = useNavigate();
  const unitData = useUnitData();
  let countryData = Country.getAllCountries();
  const [searchParams] = useSearchParams();
  const [productDetails, setProductDetails] = useState({});
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [showUnspc, setShowUnspc] = useState(false);
  const [searchOptions, setSearchOptions] = useState([]);
  const [segmentDataList, setAllSegmentDataList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [getSegmentCode, setGetSegmentCode] = useState([]);
  const [allAllDataList, setAllDataList] = useState([]);
  const [segmentCode, setSegmentCode] = useState("");
  const [addProductId, setAddProductId] = useState("");
  const [getDataSegment, setDataSegment] = useState("");
  const [allUnspcFamily, setUnspcFamily] = useState([]);
  const [allUnspcClass, setUnspcClass] = useState([]);
  const [allUnspcComodity, setUnspcComodity] = useState([]);
  const [getDataFamily, setDataFamily] = useState("");
  const [supplier, setSupplier] = useState([]);
  const [vat, setVat] = useState("");
  const [month, setMonth] = useState("");
  const [isToggleddata, setToggleddata] = useState(false);
  const [finalStartDate, setFinalStartDate] = useState("");
  const [getProductId, setProductId] = useState([]);
  const [finalEndDate, setFinalEndDate] = useState("");
  const [editData, setEditData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [picture, setPicture] = useState([]);
  const [chooseFile, setChooseFile] = useState();
  const [imageShow, setImageShow] = useState(false);
  const [imageIndex, setImageIndex] = useState();
  const [imageData, setImageData] = useState();
  const [saleUnitQty, setSaleUnitQnt] = useState(1);
  const [baseUnitQty, setbaseUnitQnt] = useState(1);
  const [subUnitQty, setSubUnitQnt] = useState(1);
  const [co2UnitQty, setCo2UnitQnt] = useState(1);
  const [saleUnitPrice, setSaleUnitPrice] = useState();
  const [purchasePrice, setPurchasePrice] = useState(1);
  const [co2UnitPrice, setCo2UnitPrice] = useState(0);
  const [priceDiscount, setPriceDiscount] = useState(0);
  const [kgCo2Data, setKgCo2Data] = useState(0);
  const [kgCo2_per_co2, setKgCo2PerCo2] = useState(0);
  const [kgCo2_per_sale_unit, setKGCO2perSaleUnit] = useState(0);
  const [barcodeValue, setBarcodeValue] = useState();

  const _GET_PRODUCT_DETAILS = async () => {
    setIsLoading(true);
    getProductById(searchParams.get("id"), (res) => {
      // console.log("res.data.getProductDetails", res?.data?.getProductDetails);
      setProductDetails(res?.data?.getProductDetails);
      setSaleUnitPrice(res?.data?.getProductDetails?.salePrice || 0);
      const salePrice = res?.data?.getProductDetails?.salePrice || 0;
      const discount = res?.data?.getProductDetails?.discount || 0;
      const calprice = discount
        ? salePrice - Number((Number(discount) * salePrice) / 100).toFixed(2)
        : salePrice;

      setPurchasePrice(calprice);
      setPriceDiscount(discount);
      // setPurchasePrice(res?.data?.getProductDetails?.purchasePrice || 0);
      setSaleUnitQnt(res?.data?.getProductDetails?.saleUnitQty || 0);
      setbaseUnitQnt(res?.data?.getProductDetails?.baseUnit || 0);
      setSubUnitQnt(res?.data?.getProductDetails?.subUnitQty || 0);
      setCo2UnitQnt(res?.data?.getProductDetails?.co2_qty || 0);
      setCo2UnitPrice(res?.data?.getProductDetails?.co2_data || 0);
      setKgCo2Data(res?.data?.getProductDetails?.KgCo2 || 0);
      setKgCo2PerCo2(Number(res?.data?.getProductDetails?.kgco2_co2_unit) || 0);
      setVat(Number(res?.data?.getProductDetails?.VATPercent) || 0);
      setBarcodeValue(res?.data?.getProductDetails?.bar_code || "");
      setIsLoading(false);
    });
  };

  const handleBarcodeChange = (e) => {
    const newValue = e.target.value;
    setBarcodeValue(newValue);
  };

  const PurchasePriceCalculate = useCallback(() => {
    const calprice = priceDiscount
      ? saleUnitPrice - Number((Number(priceDiscount) * saleUnitPrice) / 100)
      : saleUnitPrice;
    return Number(calprice).toFixed(2);
  }, [priceDiscount, saleUnitPrice]);

  const handleDiscountChange = (value) => {
    setPriceDiscount(value);
    const calprice = value
      ? saleUnitPrice - Number((Number(value) * saleUnitPrice) / 100).toFixed(2)
      : saleUnitPrice;

    setPurchasePrice(calprice);
  };

  useEffect(() => {
    _GET_PRODUCT_DETAILS();
    getPurchaseHistory();
    localStorage.setItem("tab", "Products");
  }, []);
  const getPurchaseHistory = async () => {
    const data = {
      productId: searchParams.get("id"),
    };
    const response = await instance.post(
      `/customer/product/get-purchase-history-by-id`,
      data
    );
    setPurchaseHistory(response?.data?.data?.purchaseHistories);
  };
  const handleCloseUnspc = () => {
    setShowUnspc(false);
  };
  const _SELECT_UNSPSC = (data) => {
    setIsLoading(true);
    // console.log(data,"myData");
    getUnspcAdd(data, selected, (r) => {
      if (r.success === true) {
        toast.success(r.message);
        setShowUnspc(false);
        setSegmentCode("");
        afterUpdateUnspschandledata();
        _GET_PRODUCT_DETAILS();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };
  const _SEARCH_UNSPSC = debounce((data) => {
    // console.log(e,"search Data")
    setIsLoading(true);
    searchUnspc(data, (res) => {
      convertToArrayOfObjects(res.data);
      // console.log(res.data,"resData")
      // console.log(convertToArrayOfObjects(res.data),'search data')
      // const flattenedData = Object.assign({}, ...res.data.map(item => item));
      // console.log(flattenedData,"flattenedData");
    });
    // console.log(e.target.value,"searchData")
  }, 500);
  function convertToArrayOfObjects(array) {
    const result = [];
    for (let index = 0; index < array.length; index++) {
      result.push({
        value: {
          code: array[index].Segment.Segment,
          point: "Segment",
          title: array[index].Segment.SegmentTitle,
          id: array[index].Segment.id,
        },
        label: `${array[index].Segment.SegmentTitle} ( Segment - ${array[index].Segment.Segment})`,
      });
      result.push({
        value: {
          code: array[index].Family.Family,
          point: "Family",
          title: array[index].Family.FamilyTitle,
          id: array[index].Family.id,
        },
        label: `${array[index].Family.FamilyTitle} ( Family - ${array[index].Family.Family})`,
      });
      result.push({
        value: {
          code: array[index].Class.Class,
          point: "Class",
          title: array[index].Class.ClassTitle,
          id: array[index].Class.id,
        },
        label: `${array[index].Class.ClassTitle} ( Class - ${array[index].Class.Class})`,
      });
      result.push({
        value: {
          code: array[index].Commodity.Commodity,
          point: "Commodity",
          title: array[index].Commodity.CommodityTitle,
          id: array[index].Commodity.id,
        },
        label: `${array[index].Commodity.CommodityTitle} ( Commodity - ${array[index].Commodity.Commodity})`,
      });
    }
    let jsonObject = result.map(JSON.stringify);
    let uniqueSet = new Set(result.map(JSON.stringify));
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    // console.log(uniqueArray,"res1")
    setSearchOptions(uniqueArray.filter((item) => item.value !== null));
    setIsLoading(false);
    // return uniqueArray;
  }
  const onDataSegment = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataSegment(e);
    getSegmentUnspcAdd(e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcFamily(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataFamily = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getFamilyUnspcAdd(getDataSegment, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcClass(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onUnspc = (e, data = "") => {
    e.preventDefault();
    setShowUnspc(true);
    if (data) {
      setSelected([data]);
    }
  };

  const onDataClass = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getClassUnspcAdd(getDataSegment, getDataFamily, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcComodity(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };
  const afterUpdateUnspschandledata = () => {
    setIsLoading(true);
    // setToggleddata(!isToggleddata);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    // console.log("evennnnt--->", name, value);
    setEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const searchPage = () => {
    navigate("/segment");
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    // console.log("editData", editData);
    const data = editData;
    saleUnitQty !== productDetails?.saleUnitQty &&
      (data.saleUnitQty = saleUnitQty);
    baseUnitQty !== productDetails?.baseUnit && (data.baseUnit = baseUnitQty);
    subUnitQty !== productDetails?.subUnitQty && (data.subUnitQty = subUnitQty);
    co2UnitQty !== productDetails?.co2_qty && (data.co2_qty = co2UnitQty);
    kgCo2_per_sale_unit !== productDetails?.KgCO2_per_Sale_unit &&
      (data.KgCO2_per_Sale_unit = kgCo2_per_sale_unit);
    kgCo2_per_co2 &&
      kgCo2_per_co2 !== Number(productDetails?.kgco2_co2_unit) &&
      (data.kgco2_co2_unit = kgCo2_per_co2);
    priceDiscount !== productDetails?.discount &&
      (data.discount = priceDiscount);
    baseUnitQty !== productDetails?.baseUnit && (data.net_weight = baseUnitQty);
    barcodeValue !== productDetails?.bar_code && (data.bar_code = barcodeValue);
    for (const key in data) {
      if (data[key] === null || data[key] === "" || data[key] === undefined) {
        delete data[key];
      }
    }
    data.productId = Number(searchParams.get("id"));
    // console.log("dataaa->", data);
    try {
      const response = await instance.post(
        `/customer/product/edit-product`,
        data
      );
      // console.log("response----->", response);
      setIsLoading(false);
      toast.success(response?.data?.message);
    } catch (err) {
      setIsLoading(false);
      // console.log(err);
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    setImageData(event.target.files);
    const newPictures = [];

    if (files) {
      // Loop through all selected files
      Array.from(files).forEach((file) => {
        // Check if the file is an image
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = () => {
            newPictures.push(reader.result);
            if (newPictures.length === files.length) {
              // All files have been processed
              setPicture(newPictures);
            }
          };
        } else {
          toast.error(`File ${file.name} is not a valid image file.`);
        }
      });
    }
  };
  const handleShowImage = (i) => {
    setImageIndex(i);
    setImageShow(true);
  };
  const handleFileChoose = (event) => {
    const file = event.target.files;
    setChooseFile(file);
  };

  const handleUploadfile = async () => {
    setIsLoading(true);
    let formData = new FormData();

    formData.append("productId", Number(searchParams.get("id")));
    for (let i = 0; i < chooseFile.length; i++) {
      formData.append("productFile", chooseFile[i]);
    }
    try {
      const response = await instance.post(
        `/customer/product/upload-product-file`,
        formData
      );
      _GET_PRODUCT_DETAILS();
      setChooseFile();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
      // console.log("eee", err);
    }
  };

  const handleImageUpload = async () => {
    setIsLoading(true);
    let formData = new FormData();

    formData.append("productId", Number(searchParams.get("id")));
    for (let i = 0; i < imageData.length; i++) {
      formData.append("productPic", imageData[i]);
    }

    try {
      const response = await instance.post(
        `/customer/product/upload-product-pic`,
        formData
      );
      _GET_PRODUCT_DETAILS();
      setPicture([]);
      setIsLoading(false);
      // console.log("res-6666>", response);
    } catch (err) {
      setIsLoading(false);
      setPicture([]);
      toast.error(err?.response?.data?.message);
      // console.log("errrr-->", err);
    }
  };

  // console.log("co2UnitQty", co2UnitQty);

  const getSaleUnitPrice = useCallback(() => {
    return Number(purchasePrice);
  }, [saleUnitQty, purchasePrice]);
  const getCo2UnitPrice = useCallback(() => {
    return Number(co2UnitQty)
      ? Number(purchasePrice) / Number(co2UnitQty)
      : Number(purchasePrice);
  }, [co2UnitQty, purchasePrice]);
  const baseUnitPrice = useCallback(() => {
    return Number(baseUnitQty)
      ? Number(purchasePrice) / Number(baseUnitQty)
      : Number(purchasePrice);
  }, [baseUnitQty, purchasePrice]);
  const subUnitPrice = useCallback(() => {
    return Number(subUnitQty)
      ? Number(purchasePrice) / Number(subUnitQty)
      : Number(purchasePrice);
  }, [subUnitQty, purchasePrice]);

  const baseUnitKgCO2e = useCallback(() => {
    return Number(baseUnitQty) && co2UnitQty
      ? (
          (Number(co2UnitQty) * Number(kgCo2_per_co2 || kgCo2Data)).toFixed(2) /
          Number(baseUnitQty)
        ).toFixed(2)
      : 0;
  }, [co2UnitQty, baseUnitQty, kgCo2Data, kgCo2_per_co2]);
  const saleUnitKgCO2e = useCallback(() => {
    return co2UnitQty
      ? (Number(co2UnitQty) * Number(kgCo2_per_co2 || kgCo2Data)).toFixed(2)
      : 0;
  }, [co2UnitQty, kgCo2Data, kgCo2_per_co2]);
  const subUnitKgCO2e = useCallback(() => {
    return Number(subUnitQty) && baseUnitQty && co2UnitQty
      ? (
          (Number(co2UnitQty) * Number(kgCo2_per_co2 || kgCo2Data)).toFixed(2) /
          Number(subUnitQty)
        ).toFixed(2)
      : 0;
  }, [co2UnitQty, baseUnitQty, subUnitQty, kgCo2Data, kgCo2_per_co2]);
  const co2UnitKgCO2e = useCallback(() => {
    return kgCo2_per_co2
      ? Number(kgCo2_per_co2).toFixed(2)
      : Number(kgCo2Data).toFixed(2);
  }, [kgCo2_per_co2]);

  useEffect(() => {
    if (co2UnitQty) {
      setKGCO2perSaleUnit(
        (Number(co2UnitQty) * Number(kgCo2_per_co2 || kgCo2Data)).toFixed(2)
      );
    }
  }, [co2UnitQty, kgCo2Data]);

  // Search Section
  const searchUnspsc = debounce((input) => {
    setSearch("");
    setPage(1);
    setTotalSearchResult(0);
    setSearchResults([]);

    if (!input) {
      return;
    }

    setSearch(input);
  }, 1500);

  const loadMoreResults = () => {
    setPage(page + 1);
  };

  function getSearchResults() {
    setIsSearchLoading(true);

    searchUnspc(search, page, "user", (res) => {
      if (!res.data || res.data.results.length === 0) {
        setSearchResults([]);
        setIsSearchLoading(false);
        return;
      }

      setSearchResults((prevResults) => [...prevResults, ...res.data.results]);
      setTotalSearchResult(res.data.total);
      setSearchResultsEnd(res.data.reachedEnd);
      setIsSearchLoading(false);
    });
  }

  function getUnspscData(result) {
    toast.dismiss();

    toast.warning(
      <div className="toast-content">
        <div className="toast-message">
          Are you sure you want to add this UNSPSC?
        </div>
        <div className="button-container">
          <button
            className="yes-button"
            onClick={() => {
              // Proceed with the function if "Yes" is clicked
              getSelectedUnspscDetails(result, (res) => {
                if (res.success) {
                  addUnspscData(res.data.details, selected, (r) => {
                    if (r.success === true) {
                      toast.success(r.message);
                      setPage(1);
                      setSearchResults([]);
                      setSearch("");
                      handleCloseUnspc();
                      afterUpdateUnspschandledata();
                      _GET_PRODUCT_DETAILS();
                    } else {
                      toast.error(r.message);
                    }
                  });
                }
              });
            }}
          >
            Yes
          </button>
          <button
            className="no-button ms-2"
            onClick={() => {
              // Dismiss the toast if "No" is clicked
              toast.dismiss();
            }}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: true, // Keep the toast open until user interacts
        closeOnClick: true, // Prevent closing the toast on click
      }
    );
  }

  useEffect(() => {
    getSearchResults();
  }, [search]);

  useEffect(() => {
    if (page > 1) {
      getSearchResults();
    }
  }, [page]);

  return (
    <div className="container-fluid">
      <div className="dbMain prdtsbg">
        <Leftpanel />
        <div className="dbRight">
          <Header
            link="/products"
            breadcm=""
            title={t("Product Details")}
            description=""
          />
          <div className="commonBase prddt">
            {isLoading && <SpinnerComponent isLoading={isLoading} />}
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column"
            >
              <div className="masBlock">
                <div className="prdNewTable mb-4">
                  <h5>{t("General information")}</h5>
                  <table>
                    <tr>
                      <th>{t("Supplier short name")}</th>
                      <td>
                        <input
                          className="productEditInput"
                          name="supplierShortName"
                          type="text"
                          defaultValue={productDetails?.supplierShortName}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Product Name")}</th>
                      <td>
                        <textarea
                          className="productEditInput"
                          name="name"
                          type="text"
                          defaultValue={productDetails?.name}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Product number")}</th>
                      <td>
                        <input
                          className="productEditInput"
                          name="number"
                          type="text"
                          defaultValue={productDetails?.number}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>{t("UNSPSC")}</th>
                      {productDetails?.unspsc ? (
                        <td
                          className="text-center"
                          style={{
                            fontSize: "16px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {productDetails?.type === "Family"
                            ? productDetails?.unspscFamily?.FamilyTitle
                            : productDetails?.type === "Class"
                            ? productDetails?.unspscClass?.ClassTitle
                            : productDetails?.type === "Commodity"
                            ? productDetails?.unspscCommodity?.CommodityTitle
                            : productDetails?.type === "Segment"
                            ? productDetails?.unspscSegment?.SegmentTitle
                            : ""}
                          {`(${productDetails?.unspsc})`}
                          &nbsp;
                          <Link to="#">
                            <i
                              className="fa-light fa-pen"
                              onClick={(e) => onUnspc(e, productDetails)}
                            ></i>
                          </Link>
                        </td>
                      ) : (
                        <td
                          className="text-center"
                          style={{ fontSize: "16px" }}
                        >
                          <Link
                            to={"javascript:void(0)"}
                            onClick={(e) => onUnspc(e, productDetails)}
                          >
                            <i className="fa-regular fa-circle-plus"></i>
                          </Link>
                        </td>
                      )}
                    </tr>
                    <tr>
                      <th>{t("Manufacturer name")}</th>
                      <td>
                        <input
                          className="productEditInput"
                          name="manufactureName"
                          type="text"
                          defaultValue={productDetails?.manufactureName}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Manufacturer product number")}</th>
                      <td>
                        <input
                          className="productEditInput"
                          name="manufactureProductNumber"
                          type="text"
                          defaultValue={
                            productDetails?.manufactureProductNumber
                          }
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>{t("Manufacturer country of origin")}</th>
                      <td>
                        <select
                          className="productEditInput"
                          name="country"
                          onChange={(e) => handleInputChange(e)}
                        >
                          <option value="">Select Country</option>
                          {countryData?.map((data) => (
                            <option
                              value={data?.isoCode}
                              selected={
                                productDetails?.country === data?.isoCode
                              }
                            >
                              {data?.name}
                            </option>
                          ))}
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Detailed product information")}</th>
                      <td>
                        <textarea
                          className="productEditInput"
                          name="detailsInfo"
                          type="text"
                          defaultValue={productDetails?.detailsInfo}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <div className="masBlock">
                <div className="prdNewTable mb-4">
                  <h5>{t("Web store url")}</h5>
                  <table>
                    <tr>
                      <th>{t("Web store url")}</th>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          value={""}
                          onChange={() => console.log("hii")}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Product web store url")}</th>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          value={productDetails?.product_web_store_url}
                          onChange={() => console.log("hii")}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Picture")}</th>
                      <td>
                        {picture?.length ? (
                          <Button
                            variant="success"
                            style={{
                              height: "28px",
                              padding: "2px 2px",
                              marginBottom: "10px",
                            }}
                            onClick={handleImageUpload}
                          >
                            {t("Upload")}
                          </Button>
                        ) : (
                          <label className="custom-file-upload">
                            <input
                              type="file"
                              accept="image/*"
                              multiple
                              className="productEditInput"
                              onChange={(e) => handleFileChange(e)}
                              style={{ display: "none" }}
                            />
                            <span>
                              {t("Choose Image")}{" "}
                              <i className="bi bi-cloud-arrow-up"></i>
                            </span>
                          </label>
                        )}
                        <br />

                        {productDetails?.productDocs?.length !== 0 &&
                          productDetails?.productDocs?.map((data, i) => (
                            <img
                              src={data?.filePath}
                              alt="picture"
                              style={{
                                height: "30px",
                                marginLeft: "10px",
                                cursor: "pointer",
                                border: "1px solid gray",
                                borderRadius: "5px",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }} // Added margin-left for spacing
                              onClick={() => handleShowImage(data?.filePath)}
                            />
                          ))}

                        {picture.length !== 0 &&
                          picture.map((data, i) => (
                            <img
                              src={data}
                              alt="picture"
                              style={{
                                height: "30px",
                                marginLeft: "10px",
                                cursor: "pointer",
                                border: "1px solid gray",
                                borderRadius: "5px",
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              }} // Added margin-left for spacing
                              onClick={() => handleShowImage(data)}
                            />
                          ))}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("Url to a picture")}</th>
                      <td>
                        <input
                          type="text"
                          className="productEditInput"
                          onChange={(event) =>
                            console.log("event----->", event.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        {t(
                          "Attachment documents with further product information"
                        )}
                      </th>
                      <td>
                        <label className="custom-file-upload">
                          {chooseFile?.length ? (
                            <Button
                              style={{ height: "28px", padding: "2px 2px" }}
                              onClick={handleUploadfile}
                            >
                              {t("Upload")}
                            </Button>
                          ) : (
                            <>
                              <input
                                type="file"
                                className="productEditInput"
                                multiple
                                onChange={(event) => handleFileChoose(event)}
                              />
                              <span>
                                {t("Choose File")}{" "}
                                <i className="bi bi-cloud-arrow-up"></i>
                              </span>
                            </>
                          )}
                        </label>

                        <br />
                        {productDetails?.productFileDocs?.length !== 0 &&
                          productDetails?.productFileDocs?.map(
                            (data, index) => (
                              <a
                                href={data?.filePath}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={index}
                              >
                                {data?.filePath}
                              </a>
                            )
                          )}
                      </td>
                    </tr>
                  </table>
                </div>

                <div className="prdNewTable mb-4">
                  <table>
                    <tr>
                      <th>{t("Bar Code")}</th>
                      <td>
                        <div>
                          <input
                            type="text"
                            value={barcodeValue}
                            onChange={handleBarcodeChange}
                            className="productEditInput"
                            placeholder="Enter Barcode"
                          />
                          {barcodeValue && (
                            <Barcode
                              value={barcodeValue}
                              height={50}
                              className="productEditInput"
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </Masonry>
            <div className="masBlock">
              <div
                className="prdNewTable mb-4"
                style={{ width: "max-content" }}
              >
                <table>
                  <thead>
                    <tr>
                      <th>{t("List price")}</th>
                      <th>{t("Discount %")}</th>
                      <th>{t("Purchase Price")}</th>
                      <th>{t("VAT %")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="listprice"
                          placeholder="Enter List Price"
                          value={saleUnitPrice}
                          // onChange={(e) => console.log(e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="discount"
                          placeholder="Enter Discount"
                          value={priceDiscount}
                          onChange={(e) => handleDiscountChange(e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="purchaseprice"
                          placeholder="Enter Purchase Price"
                          value={PurchasePriceCalculate()}
                          // onChange={(e) => console.log(e.target.value)}
                          readOnly
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="VATPercent"
                          placeholder="Enter vat percentage"
                          value={vat}
                          // onChange={(e) => console.log(e.target.value)}
                          readOnly
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="masBlock">
              <div
                className="prdNewTable mb-4"
                style={{ width: "max-content" }}
              >
                <table>
                  <tbody>
                    <tr>
                      <td style={{ border: "none" }}>
                        <td style={{ fontWeight: "bold", border: "none" }}>
                          {t("KgCO2 per CO2 unit")}
                        </td>
                      </td>
                      <td style={{ border: "none" }}>
                        <label>{t("Manufacturer value : ")}</label>
                        <input
                          className="productEditInput"
                          type="text"
                          name="kgco2_co2_unit"
                          value={kgCo2_per_co2}
                          style={{ width: "25%" }}
                          onChange={(e) => setKgCo2PerCo2(e.target.value)}
                        />
                      </td>
                      <td style={{ border: "none" }}>
                        <label>{t("Stakeholder value : ")}</label>
                        {productDetails?.KgCo2 && (
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-UNSPSCKGCO2">
                                {productDetails?.stackHolderSouce}
                              </Tooltip>
                            }
                          >
                            <input
                              className="productEditInput"
                              type="text"
                              name="UNSPSCKGCO2"
                              style={{ width: "50px" }}
                              value={productDetails?.KgCo2}
                            />
                          </OverlayTrigger>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="masBlock">
              <div
                className="prdNewTable mb-4"
                style={{ width: "max-content" }}
              >
                <h5>{t("Units of measures")}</h5>
                <table>
                  <thead>
                    <tr>
                      <th>{t("Units of measures")}</th>
                      <th style={{ textAlign: "center" }}>{t("Unit")}</th>
                      <th>{t("Qty")}</th>
                      <th>{t("Price")}</th>
                      <th>{t("KgCo2e")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{t("Sale unit")}</td>
                      <td>
                        <select
                          className="productEditInput  form-control"
                          name="sale_unit_of_measure"
                          onChange={(e) => handleInputChange(e)}
                        >
                          <option>{t("Select Sale Unit")}</option>
                          {unitData?.map((data, index) => (
                            <option
                              key={index}
                              value={data.common_unit}
                              selected={
                                productDetails?.sale_unit_of_measure ===
                                data.common_unit
                              }
                            >
                              {data.common_unit}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="saleUnitQty"
                          value={1}
                          // onChange={(e) => setSaleUnitQnt(e.target.value)}
                          readOnly
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="salePrice"
                          value={getSaleUnitPrice().toFixed(2)}
                          // onChange={(e) => handleInputChange(e)}
                          readOnly
                        />
                      </td>
                      <td>
                        {" "}
                        <input
                          className="productEditInput"
                          type="text"
                          name="co2_data"
                          value={saleUnitKgCO2e()}
                          onChange={(e) => handleInputChange(e)}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>{t("Base unit")}</td>
                      <td>
                        <select
                          className="productEditInput form-control"
                          name="base_unit_of_measure"
                          onChange={(e) => handleInputChange(e)}
                        >
                          <option>{t("Select Base Unit")}</option>
                          {unitData?.map((data, index) => (
                            <option
                              key={index}
                              value={data.common_unit}
                              selected={
                                productDetails?.base_unit_of_measure ===
                                data.common_unit
                              }
                            >
                              {data.common_unit}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="baseUnit"
                          value={baseUnitQty}
                          onChange={(e) => setbaseUnitQnt(e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="baseUnitPrice"
                          value={baseUnitPrice().toFixed(2)}
                          readOnly
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="co2_data"
                          value={baseUnitKgCO2e()}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>{t("Sub unit")}</td>
                      <td>
                        <select
                          className="productEditInput form-control"
                          name="sub_unit_of_measure"
                          onChange={(e) => handleInputChange(e)}
                        >
                          <option>{t("Select Sub Unit")}</option>
                          {unitData?.map((data, index) => (
                            <option
                              key={index}
                              value={data.common_unit}
                              selected={
                                productDetails?.sub_unit_of_measure ===
                                data.common_unit
                              }
                            >
                              {data.common_unit}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="subUnitQty"
                          value={subUnitQty}
                          onChange={(e) => setSubUnitQnt(e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="baseUnitPrice"
                          value={subUnitPrice().toFixed(2)}
                          readOnly
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="co2_data"
                          value={subUnitKgCO2e()}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>{t("CO2 unit")}</td>
                      <td>
                        <select
                          className="productEditInput form-control"
                          name="co2_unt_measure"
                          onChange={(e) => handleInputChange(e)}
                        >
                          <option>{t("Select CO2 Unit")}</option>
                          {unitData?.map((data, index) => (
                            <option
                              key={index}
                              value={data.common_unit}
                              selected={
                                productDetails?.co2_unt_measure ===
                                data.common_unit
                              }
                            >
                              {data.common_unit}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="co2_qty"
                          value={co2UnitQty}
                          onChange={(e) => setCo2UnitQnt(e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name=""
                          value={getCo2UnitPrice().toFixed(2)}
                          readOnly
                        />
                      </td>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="co2_data"
                          value={co2UnitKgCO2e()}
                          readOnly
                        />
                      </td>
                    </tr>
                  </tbody>
                  {/* <tr>
                      <th>Gross weight</th>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="grossWeight"
                          defaultValue={productDetails?.grossWeight}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Net weight</th>
                      <td>
                        <input
                          className="productEditInput"
                          name="netWeight"
                          type="text"
                          defaultValue={productDetails?.netWeight}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Sale Unit</th>
                      <td>
                        <select
                          className="productEditInput no-arrow"
                          name="sale_unit_of_measure"
                        >
                          <option>Select Sale Unit</option>
                          <option>
                            {productDetails?.sale_unit_of_measure}
                          </option>
                        </select>
                        <input
                          className="productEditInput"
                          name="sale_unit_of_measure"
                          type="text"
                          defaultValue={productDetails?.sale_unit_of_measure}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Base Unit</th>
                      <td>
                        <input
                          className="productEditInput"
                          name="base_unit_of_measure"
                          type="text"
                          defaultValue={productDetails?.base_unit_of_measure}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>Sub Unit</th>
                      <td>
                        <input
                          className="productEditInput"
                          type="text"
                          name="sub_unit_of_measure"
                          defaultValue={productDetails?.sub_unit_of_measure}
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Base Unit Quantity</th>
                      <td>
                        <input
                          className="productEditInput"
                          name="BaseQuantity"
                          type="text"
                          defaultValue={
                            productDetails?.item?.InvoicedQuantity?._text
                          }
                          onChange={(e) => handleInputChange(e)}
                        />
                      </td>
                    </tr> */}
                </table>
              </div>
            </div>
            <Button variant="success" onClick={handleUpdate}>
              {" "}
              {t("update")}
            </Button>{" "}
            &nbsp;
            {/* <span className='cgbtn mb-4'>UNSPSC Classification :</span>
                        <p>GL Key: <strong>1400</strong></p>
                        <div><div className='prdgbordr'><span>10000000</span>Live Plant and Animal Material and Accessories and Supplies</div></div>
                        <div><div className='prdgbordr'><span>13000000</span> Resin and Rosin and Rubber and Foam and Film and Elastomeric Materials</div></div>
                        <div><div className='prdgbordr'><span>14000000</span> Paper Materials and Products</div></div>
                        <span className='cgbtn mb-2 mt-4'>Unit of measure</span>
                        <div className='pdTables mt-2 mb-4'>
                            <table>
                                <tr>
                                    <td>Co2 unit: <strong>kg</strong></td>
                                    <td>Base unit: <strong>kg</strong></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Sub unit: <strong>kg</strong></td>
                                    <td>Sale unit: <strong>kg</strong></td>
                                    <td>Carbon footprint of sale unit: <strong>155</strong></td>
                                </tr>
                            </table>
                        </div>

                        <span className='cgbtn mb-2 mt-4'>Price</span>
                        <div className='pdTables mt-2 mb-4'>
                            <table>
                                <tr>
                                    <td>Sale unit price: <strong>Íkr 1500</strong></td>
                                    <td>Base unit price: <strong>Íkr 100</strong></td>
                                    <td>Sub unit price: <strong>Íkr 250</strong></td>
                                </tr>
                                <tr>
                                    <td>Discount: <strong>100</strong></td>
                                    <td>VAT (5%): <strong>250</strong></td>
                                    <td>Purchase Price: <strong>250</strong></td>
                                </tr>
                            </table>
                        </div>


                        <span className='cgbtn mb-2 mt-4'>Environmental Issues</span>
                        <div className='pdTables mt-2 mb-4'>
                            <table>
                                <tr>
                                    <td>Manufacturer Name: <strong>John Doe</strong></td>
                                    <td>Country of Origin: <strong>Iceland</strong></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Manufacturer Product Number: <strong>500</strong></td>
                                    <td>GHG Emission: <strong>Lorem Ipsum</strong></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div> */}
            {/* <span className='cgbtn mb-2 mt-4'>Environmental Friendly</span>
                        <p>Environmental Friendly: <strong>Product</strong></p>
                        <p>Why it is environmentally friendly:</p>
                        <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.</p> */}
            <Modal
              size="lg"
              show={showUnspc}
              onHide={handleCloseUnspc}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <h5 className="mb-0">{t("add")} UNSPSC</h5>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="productMainScroll">
                  {search && <>Total results: {searchResults.length}</>}

                  <div className="searchParentDiv">
                    <div>
                      <input
                        className="productSearch py-2 px-4"
                        type="search"
                        placeholder="Type something to search..."
                        onChange={(e) => searchUnspsc(e.target.value)}
                      />
                    </div>
                    {search && (
                      <div className="searchResults">
                        {searchResults && searchResults.length > 0 ? (
                          <>
                            {searchResults.map((result, index) => (
                              <div
                                className="form-check d-flex justify-content-between"
                                key={index}
                                onClick={() => getUnspscData(result)}
                              >
                                <div>
                                  {index +
                                    1 +
                                    ". " +
                                    result.value +
                                    " (" +
                                    result.belongsTo +
                                    " " +
                                    result.key +
                                    ")"}
                                </div>
                                <div>
                                  <i
                                    className="fa fa-plus theme-color"
                                    aria-hidden="true"
                                    title="Click to Add"
                                  ></i>
                                </div>
                              </div>
                            ))}

                            {/* Load More Button */}
                            {totalSearchResult > searchResults.length && (
                              <div className="load-more d-flex justify-content-center">
                                {isSearchLoading ? (
                                  <button disabled>
                                    <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                                  </button>
                                ) : (
                                  !searchResultsEnd && (
                                    <button onClick={loadMoreResults}>
                                      Load More
                                    </button>
                                  )
                                )}
                              </div>
                            )}
                          </>
                        ) : (
                          <div
                            className="form-check"
                            style={{ textAlign: "center" }}
                          >
                            {isSearchLoading ? (
                              <i className="fa-solid fa-spinner fa-spin"></i>
                            ) : (
                              "No Result Found"
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </Modal.Body>
              {/* <Modal.Body>
                <div className="dbMaintable productMainScroll">
                  <Select
                    options={searchOptions}
                    placeholder={`${t("search")} + UNSPSC...`}
                    noOptionsMessage={() => "Type something UNSPSC specific"}
                    onChange={_SELECT_UNSPSC}
                    onInputChange={_SEARCH_UNSPSC}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                  />
                  <h2 className="d-flex justify-content-center">{t("OR")}</h2>

                  <h5 className="mt-4 mb-3">UNSPSC :</h5>
                  <div className="accordion unspscAccord" id="unAccordion">
                    <div className="accordion-item">
                      {segmentDataList.map((d, i) => (
                        <>
                          <button
                            value={d?.Segment}
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${i}`}
                            aria-expanded="false"
                            aria-controls="collapseOne"
                            onClick={onDataSegment.bind(
                              d?.Segment,
                              `${d?.Segment}`
                            )}
                          >
                            {t("segment_code")} : {d?.Segment}, {t("title")} :{" "}
                            {d?.SegmentTitle}
                          </button>

                          <div
                            id={`collapse${i}`}
                            className="accordion-collapse collapse"
                            aria-labelledby="hdOne"
                            data-bs-parent="#unAccordion"
                          >
                            <div className="accordion-body parentAccord">
                              <div className="accordion" id="sub-unAccordion">
                                <div className="accordion-item">
                                  {allUnspcFamily.map((f, fi) => (
                                    <>
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#sub-collapse${fi}`}
                                        aria-expanded="false"
                                        aria-controls="sub-collapseTwo"
                                        onClick={onDataFamily.bind(
                                          f?.Family,
                                          `${f?.Family}`
                                        )}
                                      >
                                        Family Code : {f?.Family}, Title :{" "}
                                        {f?.FamilyTitle}
                                      </button>
                                      <div
                                        id={`sub-collapse${fi}`}
                                        className="accordion-collapse collapse"
                                        aria-labelledby="sub-headingTwo"
                                        data-bs-parent="#sub-unAccordion"
                                      >
                                        <div className="accordion-body">
                                          <div
                                            className="accordion"
                                            id="sub-sub-unAccordion"
                                          >
                                            <div className="accordion-item">
                                              {allUnspcClass.map((c, ci) => (
                                                <>
                                                  <button
                                                    className="accordion-button collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#sub-sub-collapse${ci}`}
                                                    aria-expanded="false"
                                                    aria-controls="collapseOnesub"
                                                    onClick={onDataClass.bind(
                                                      c?.Class,
                                                      `${c?.Class}`
                                                    )}
                                                  >
                                                    {t("class_code")} :{" "}
                                                    {c?.Class},{t("title")} :{" "}
                                                    {c?.ClassTitle}
                                                  </button>
                                                  <div
                                                    id={`sub-sub-collapse${ci}`}
                                                    className="accordion-collapse collapse"
                                                    aria-labelledby="sub-sub-hdOne"
                                                    data-bs-parent="#sub-sub-unAccordion"
                                                  >
                                                    <div className="accordion-body">
                                                      <div
                                                        className="accordion"
                                                        id="sub-sub-sub-unAccordion"
                                                      >
                                                        <div className="accordion-item">
                                                          {allUnspcComodity.map(
                                                            (co, coi) => (
                                                              <button
                                                                className="accordion-button collapsed"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#sub-sub-sub-collapseOne"
                                                                aria-expanded="false"
                                                                aria-controls="collapseOnesub"
                                                              >
                                                                Commodity Code :{" "}
                                                                {co?.Commodity},
                                                                Title :{" "}
                                                                {
                                                                  co?.CommodityTitle
                                                                }
                                                              </button>
                                                            )
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              ))}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="d-flex">
                  <button className="commonButton ms-auto p-2" onClick={searchPage}>
                    {t("View More")}
                  </button>
                </div>
              </Modal.Body> */}
            </Modal>
            <Modal
              size="sm"
              show={imageShow}
              onHide={() => setImageShow(false)}
              centered
            >
              <Modal.Header closeButton />
              <Modal.Body>
                <img
                  src={imageIndex}
                  alt="picture"
                  style={{ width: "-webkit-fill-available" }}
                />
              </Modal.Body>
            </Modal>
            <span className="cgbtn mb-0 mt-4">{t("purchaseHistory")}</span>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("Order ID")}</th>
                    <th>{t("Order Date")}</th>
                    <th>{t("Purchase Quantity")}</th>
                    <th>{t("Price")}</th>
                    <th>{t("Change Percentage")}</th>
                    {/* 
  <th>{t("Total Quantity per Base units")}</th>
  <th>{t("Base unit Price")}</th>
  <th>{t("Sale Unit")}</th>
  <th>{t("% Difference in Sale unit price")}</th> 
  */}
                  </tr>
                </thead>

                <tbody>
                  {purchaseHistory?.length > 0 &&
                    purchaseHistory?.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td data-label="Order ID">
                            <Link to="javascript:void(0)">
                              {/* {item.orderId} */}
                              {item.orderId}
                            </Link>
                          </td>
                          <td data-label="Order Date">
                            <Link to="javascript:void(0)">
                              {moment(item.createdAt).format("DD-MM-YYYY")}
                            </Link>
                          </td>
                          <td data-label="Total Quantity per Base units">
                            <Link to="javascript:void(0)">
                              {item.totalQuantityPerBaseUnits}
                            </Link>
                          </td>
                          <td data-label="Base unit Price">
                            <Link to="javascript:void(0)">
                              {item.currencyType}{" "}
                              {item.baseUnitPrice.toFixed(2)}
                            </Link>
                          </td>
                          <td data-label="Change Percentage">
                            <Link to="javascript:void(0)">
                              {item?.changePercentage
                                ? `${Number(item?.changePercentage).toFixed(
                                    2
                                  )} %`
                                : "----"}
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productdetails;
